import { devtools } from 'zustand/middleware';

import { type AutoPickedItem } from '@app/client/common/structs';
import { create } from '@app/store/zustand/helpers/create';

interface FantasyAutopickedState {
    autopicked: Array<AutoPickedItem>;
    addAutoPickedItem: (item: AutoPickedItem) => void;
    removeAutopickedItem: (item: AutoPickedItem) => void;
    clearAutopicked: () => void;
}

export const useFantasyAutopickedStore = create<FantasyAutopickedState>()(
    devtools(
        (set) => ({
            autopicked: [] as Array<AutoPickedItem>,
            clearAutopicked: () => set(() => ({ autopicked: [] as Array<AutoPickedItem> })),
            addAutoPickedItem: (item) => set((state) => ({ autopicked: [...state.autopicked, item] })),
            removeAutopickedItem: (item) => {
                return set((state) => ({
                    autopicked: state.autopicked.filter(
                        (autoPickedItem) =>
                            !(autoPickedItem.slug === item.slug && autoPickedItem.fw_slug === item.fw_slug),
                    ),
                }));
            },
        }),
        { name: 'fantasy-autopicked-state-storage' },
    ),
);
